/**
 * Artists ページのスクロールアニメーション初期化
 */

(function() {
    'use strict';

    /**
     * ヒーローセクションの下向き矢印アイコンクリック時にスクロール
     */
    function initHeroScrollDown() {
        const heroScrollDown = document.querySelector('#artists-hero .hero-scroll-down');
        if (!heroScrollDown) {
            console.warn('hero-scroll-down element not found');
            return;
        }
        
        console.log('hero-scroll-down element found, setting up click handler');
        
        // 即座にイベントリスナーを設定（Lenisの初期化を待たない）
        heroScrollDown.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            console.log('hero-scroll-down clicked');
            
            const nextSection = document.querySelector('article');
            if (!nextSection) {
                console.warn('nextSection (article) not found');
                return;
            }
            
            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            const additionalOffset = 120;
            const targetPosition = nextSection.offsetTop - headerHeight + additionalOffset;
            
            console.log('Scrolling to position:', targetPosition, 'Lenis available:', !!window.lenis);
            
            // Lenisが利用可能な場合はLenisを使用、そうでなければ通常のscrollTo
            if (window.lenis) {
                window.lenis.scrollTo(targetPosition, {
                    duration: 1.2,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                    offset: 0
                });
            } else {
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
        
        console.log('Click handler attached to hero-scroll-down');
    }

    /**
     * ページ初期化
     */
    function initArtistsPage() {
        initHeroScrollDown();
    }

    // DOMContentLoadedで確実に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initArtistsPage);
    } else {
        initArtistsPage();
    }
})();

